<template>
    <div class="mx-auto max-w-page w-full lg:mt-10 lg:px-14 px-0 desktop-large:px-4 py-0 min-h-full grow">
        <div class="flex flex-col lg:grid grid-cols-12 h-full grid-rows-1 px-6 lg:px-0 pt-7 lg:pt-0"
            :style='{
                "min-height": "calc(100vh - "+minGridHeight+"px)"
            }'
        >
            <div class="lg:col-span-3 lg:border-r lg:border-grey-500 lg:pr-14"
                v-if='hasSlotLeft && forceHideLeft == false'
            >
                <slot name='left' />
            </div>

            <slot name='full' />

            <div :class="{
                'lg:col-span-6': hasSlotRight && hasSlotLeft,
                'lg:col-span-9': (!hasSlotRight && hasSlotLeft) || (hasSlotRight && !hasSlotLeft),
                'lg:col-span-12': !hasSlotRight && !hasSlotLeft,
            }">
                <slot name='middle' />
            </div>

            <div class="lg:col-span-3 lg:border-l lg:border-grey-500 lg:pl-14"
                v-if='hasSlotRight'
            >
                <slot name='right' />
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            hasTabs: { type: Boolean, default: false },
            forceHideLeft: { type: Boolean, default: false },
        },

        computed: {
            minGridHeight() {
                return !this.hasTabs ? 220 : 224
            },

            hasSlotLeft() {
                return !!this.$slots['left']
            },

            hasSlotMiddle() {
                return !!this.$slots['middle']
            },

            hasSlotRight() {
                return !!this.$slots['right']
            },
        },
    }
</script>

